export const AGENT_NAME = {
    ONBOARDING: 'onboarding',
    BUDGET_NEGOTIATION: 'budget_negotiation',
    CAMPAIGN_UNDERPERFORMING: 'campaign_underperforming',
    REPORTING_AGENT: 'reporting_agent',
};

export const MESSAGE_DIRECTION = {
    INCOMING: 'incoming',
    OUTGOING: 'outgoing',
};
